var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.routerInfo.hidden)?_c(_vm.menuComponent,{tag:"component",attrs:{"router-info":_vm.routerInfo}},[(_vm.routerInfo.children&&_vm.routerInfo.children.length)?_vm._l((_vm.routerInfo.children),function(item){return _c('recursive-menu',{key:item.name,attrs:{"router-info":item}})}):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c6b8838","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/components/recursive.vue
// module id = null
// module chunks = 